import Icon from './Icon';
import { useDispatch, useSelector } from "react-redux";
import { hidePopup } from '../../store/uiSlice';

const ConfirmPopup = () => {
    let { 
        title, message, action, 
        payload, negativeAction, negativePayload 
    } = useSelector(state => state.ui.popup);
    let dispatch = useDispatch();

    const close = (e) => {
        if (e) {
            e.preventDefault();
        }
        
        dispatch(hidePopup());
    };

    const positiveClick = (e) => {
        e.preventDefault();
        close();
        
        dispatch({ type: action, payload: payload });
    }

    const negativeClick = (e) => {
        e.preventDefault();
        close();
        dispatch({ type: negativeAction, payload: negativePayload });
    }

    const positiveLabel = negativeAction ? 'Yes' : 'OK';

    return (
        <div className={ "popup" + (action ? " popup-show" : "")}>
            <div className="popup-overlay"></div>

            <div className="popup-wrapper">
                <div className="popup-content">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title">{title}</h5>
                            <div>
                                <a href="/#" onClick={close}>
                                    <Icon icon="x"/>
                                </a>     
                            </div>
                        </div>

                        <div className="card-body">
                            <p>{message}</p>

                            <div className="actions">

                                { negativeAction &&
                                    <a href="/#" onClick={negativeClick} className="btn btn-info">
                                        No        
                                    </a>
                                }
                                
                                <a href="/#" onClick={positiveClick} className="btn btn-primary">
                                    { positiveLabel }
                                </a>
                            </div>                
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmPopup;